import { Formatters, Messages } from '../../../codegen/Localize';
import { simpleActionErrorMsg } from '../../../commonInfra/contentActions/ActionHelpers';
import { ContentActionNotification } from '../../../commonInfra/contentActions/ContentActionNotification';
import { openReactConfirmationDialog } from '../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { L10n } from '../../L10n/L10n';
import { Set } from '../../models/Set';
import { Sites } from './resources/Sites';

function showActivateSitesActionDialog(sites: Set<ISiteSettingsForServerAdmin>): Promise<any> {

  const SitesService = Sites.instance;
  const siteName: string = sites.first().settings.name;

  let dialogBody: string = Messages.confirmActivateSites({SITE_NAME: L10n.elideIfLong(siteName), ITEM_COUNT: sites.size(), ITEM_COUNT_LOC: L10n.localizedCount(sites.size())});
  const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.activateSites(),
    message: dialogBody,
    actionName: Messages.activateButtonConfirm({ ITEM_COUNT: sites.size() , ITEM_COUNT_LOC: L10n.localizedCount(sites.size()) }),
    isActionDelete: false,
    action: SitesService.activate.bind(SitesService),
    paramsForAction: sites.keys(),
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    ContentActionNotification.displaySingleToastForResult({
      items: sites,
      errors: result.errors,
      successMsg: ({ successCount }) => Messages.sitesActivateSuccess({
        ITEM_COUNT: successCount,
        ITEM_COUNT_LOC: Formatters.formatCount(successCount),
        SITE_NAME: L10n.elideIfLong(siteName),
      }),
      errorMsg: simpleActionErrorMsg(Messages.sitesActivateFailed),
    });
  });

  return Promise.resolve(dialogInstance.result);
}


export const ActivateSitesAction = {
  showActivateSitesActionDialog
};
